<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('role.title') }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button is-addOrEdit"
                    :class="{
                   'button-access-no-permission' : !checkPermissions(permsRoles.maj)
                   }"
                    @click="goOnOtherPage()">
              {{ $t('role.creationRole') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="filter = filterInput" class="column is-12">
            <b-input :placeholder="$t('remiseBancaire.recherche')" type="search" icon="magnify"
                     v-model="filterInput">
            </b-input>
          </form>
        </div>
      </div>
    </div>
    <v-client-table :data=listeRoleFilter :columns="columns" :options="options" ref="tableRole">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs.tableRole.setLimit($event)"/>
      </template>
      <div slot="displayName" slot-scope="props">
        <router-link :to="{
        name: 'c.parametrage.roles', params: { id: props.row.id }}" class="lien"
                     :class="{'text-access-no-permission':
                                   !checkPermissions(permsRoles.lecture)}">
          {{ props.row.displayName }}
        </router-link>
      </div>
      <div slot="edit" slot-scope="props" class="has-text-centered">
        <a @click="$router.push({name: 'm.parametrage.roles-edit', params: { id: props.row.id }})">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permsRoles.maj)
              }"
          >
          </b-icon>
        </a>
      </div>
      <div slot="archivage" class="has-text-centered">
        <a @click="inProgress()">
          <b-icon icon="archive" type="is-default"
                  :class="{
                'text-access-no-permission' : !checkPermissions(permsRoles.supprimer)
                }"
          >
          </b-icon>
        </a>
      </div>
      <div slot="delete" slot-scope="" class="has-text-centered">
        <a @click="checkPermissions(permsRoles.supprimer) ?
          inProgress() : showPopUp()">
          <b-icon icon="delete-forever" type="is-danger"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permsRoles.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
    </v-client-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import messageErreur from '@/services/general/messageErreur';
import inProgress from '@/services/general/inProgress';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import { ROLES } from '@/configuration/general/permissionsParametrageConf';
import TableItemsInView from '@/components/general/TableItemsInView';

const Role = createNamespacedHelpers('role');
const permissions = createNamespacedHelpers('permissions');

/*
            INFORMATION A LIRE
            Sur cette page on utilise un v-client-table car le systeme utilisé dans le back
            ne permet pas de réaliser un trie sur les différents champs
 */

export default {
  name: 'l_role',
  data() {
    return {
      filter: '',
      filterInput: '',
      permsRoles: ROLES,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    TableItemsInView,
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Role.mapActions({
      actionLoadRole: 'loadRole',
    }),
    goOnOtherPage() {
      this.$router.push({ name: 'm.parametrage.roles-add' });
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Role.mapGetters({
      listeRole: 'items',
    }),
    breadcrumb() {
      return [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('role.title'), route: '', isActive: true },
      ];
    },
    listeRoleFilter() {
      return this.listeRole.filter(item => {
        const fields = [
          item.description,
          item.displayName,
        ];
        for (let i = 0; i < fields.length; i += 1) {
          if (fields[i] && fields[i].toLowerCase().includes(this.filter.toLowerCase())) {
            return true;
          }
        }
        return false;
      });
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          description: this.$t('role.description'),
          displayName: this.$t('role.libelle'),
          edit: '',
          delete: '',
          archivage: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        columnsClasses: {
          edit: 'colonneSelected',
          delete: 'colonneSelected',
          archivage: 'colonneSelected',
        },
        sortable: ['description', 'displayName'],
      };
    },
    columns() {
      return ['displayName', 'description', 'edit', 'archivage', 'delete'];
    },
  },
  async beforeMount() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.actionLoadRole();
      this.setInformationPage(this.$t('pageParametrage.role.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
